import { MutationCache, QueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { toast } from "sonner";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: (failureCount, error) => {
        if (isAxiosError(error) && error.response) {
          const status = error.response.status;
          if (status >= 400 && status < 500) return false;
        }
        return failureCount < 2;
      },
      staleTime: 30_000,
      gcTime: 5 * 60_000,
    },
  },
  mutationCache: new MutationCache({
    onError: (error) => {
      if (isAxiosError(error)) {
        const status = error.response?.status;
        if (status === 401) return;
        if (status === 403) return toast.error("You don't have permission to do that.");
        if (status === 422) return; // form-level validation
        if (status && status >= 500) return toast.error("Server error. Please try again.");
      }
      toast.error("Something went wrong.");
    },
  }),
});
